// extracted by mini-css-extract-plugin
export default {"note-edit":"NoteEdit_note-edit__ygb29"};